import React from "react";
import { Regular6Style } from "./css/Regular6Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const regular_8_6 = (props) => {
  return (
    <Regular6Style>
      <div className="container8">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="content">
          <div className="col">
            <div className="text-wrapper">
              <TemplateText
                id={props.id}
                text={props.text}
                textStyle={props.textStyle}
                editStatus={props.editStatus}
                onInputSlideText={props.onInputSlideText}
              />
            </div>
          </div>
          <div className="col">
            <div className="vid-wrapper">
              <TemplateImage slideType={props.slideType} file={props.file} />
            </div>
          </div>
        </div>
      </div>
    </Regular6Style>
  );
};

export default regular_8_6;
